import { render, staticRenderFns } from "./visao.vue?vue&type=template&id=577880b2&"
import script from "./visao.vue?vue&type=script&lang=js&"
export * from "./visao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports